import React, { PropsWithChildren } from 'react';
import { Navbar, NavbarGroup, NavbarLogo } from '@germix/germix-react-navbar';
import LanguageNavbarMenuButton from '../navbar/LanguageNavbarMenuButton';

interface Props extends PropsWithChildren<any>
{
}
interface State
{
}

/**
 * @author Germán Martínez
 */
class Application extends React.Component<Props,State>
{
    render()
    {
        return (
<>
<Navbar>
    <NavbarGroup>
    <NavbarLogo
            href={'/'}
            image='/assets/icon.png'
            onClick={(e) =>
        {
            e.preventDefault();
            this.props.history.push(e.target.href);
        }}/>
    </NavbarGroup>

    <NavbarGroup grow={1}>
    </NavbarGroup>

    <NavbarGroup>
        <LanguageNavbarMenuButton/>
    </NavbarGroup>
</Navbar>
<div className="app">
<div className="app-content">
    { this.props.children }
</div>
</div>
</>
        );
    }
};
export default Application;
